import { render, staticRenderFns } from "./sendSmsDialog.vue?vue&type=template&id=c874a032&scoped=true&"
import script from "./sendSmsDialog.vue?vue&type=script&lang=js&"
export * from "./sendSmsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c874a032",
  null
  
)

export default component.exports